import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import { FC } from "react";
import { formatTimer } from "../utils/formatTime";
import { generateColorFromString } from "../utils/gen-random-color";
import { toTitleCase } from "../utils/toTitleCase";

interface Props {
  data: { _time: string; _value: number }[];
  fieldName: string;
  loading: boolean;
}

export const LineGraph: FC<Props> = ({ fieldName, data, loading }) => {
  const hasGraphData = data && data.length > 0;

  return (
    <Card sx={{ my: 2, boxShadow: 3, borderRadius: 2 }}>
      <CardContent>
        <Typography variant="subtitle1" gutterBottom>
          {toTitleCase(fieldName)}
        </Typography>
        <Box sx={{ height: 300 }}>
          {hasGraphData ? (
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={data}>
                <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                <XAxis
                  dataKey="_time"
                  tickFormatter={formatTimer}
                  tick={{ fontSize: 12 }}
                />
                <YAxis tick={{ fontSize: 12 }} />
                <Tooltip />
                <Line
                  type="monotone"
                  dataKey="_value"
                  stroke={generateColorFromString(fieldName)}
                  strokeWidth={2}
                  dot={false}
                  isAnimationActive={false}
                  connectNulls
                  name={fieldName}
                />
              </LineChart>
            </ResponsiveContainer>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                color: "text.secondary",
              }}
            >
              {loading ? (
                <CircularProgress />
              ) : (
                <Typography variant="body1" color="text.secondary">
                  No Data Available
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};
